import { render } from "./Direitos.vue?vue&type=template&id=63161254&scoped=true"
import script from "./Direitos.vue?vue&type=script&lang=js"
export * from "./Direitos.vue?vue&type=script&lang=js"

import "./direitos.scss?vue&type=style&index=0&id=63161254&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63161254"]])

export default __exports__